import Vue from 'vue';
import type { IDefinicionEvaluacion, IDefinicionRevision } from '@/shared/model/definicion-evaluacion.model';
import { TipoComision } from '@/shared/model/enumerations/tipo-comision.model';
import { Solucion } from '@/shared/model/solucion.model';
import Component from 'vue-class-component';
import { Emit, Prop, PropSync } from 'vue-property-decorator';
import * as personaUtils from '@/shared/util/format-util';
import type { IAreaConocimiento, ICatalogoGenerico } from '@/shared/insaculacion/entity-commons/entity.factory';
import { EstadoDocumentoFormalizacion } from '@/shared/model/enumerations/estado-documentos-formalizacion.model';
import { TipoDocumentosFormalizacion } from '@/shared/model/enumerations/tipo-documentos-formalizacion';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import { INivelSniSelect, NivelSni } from '@/shared/model/enumerations/niveles-sni.model';
import { TipoVigencia } from '@conacyt/historicopersonasms-client';
import { TipoVigencia as TipoVigenciaEnum } from '@/shared/model/enumerations/tipo-vigencia.model';
import { TipoSolicitud } from '@conacyt/perfil-usuario-client';

export interface CatTipoComision {
  value?: string | null;
  text?: string | null;
  disabled: boolean;
}

/**
 * Componente para mostrar los filtros de búsqueda
 */
@Component
export default class FiltrosComponent extends Vue {
  // Catálogos
  @Prop({ required: true, type: Array<Solucion> }) public soluciones: Array<Solucion>;
  @Prop() public tipoComisiones: Array<CatTipoComision>;
  @Prop() public areas: Array<IAreaConocimiento>;
  @Prop() public estadosDocumentos: Array<EstadoDocumentoFormalizacion>;
  @Prop() public tipoSoluciones: Array<ICatalogoGenerico>;
  @Prop() public estadosSolicitud: Array<EstadoSolicitud>;
  @Prop() public tiposDocumento: Array<TipoDocumentosFormalizacion>;
  @Prop() public nivelesSni: Array<INivelSniSelect>;
  @Prop() public tiposVigencia: Array<TipoVigencia | TipoVigenciaEnum>;
  @Prop() public tiposProcesoAyudantes: Array<ICatalogoGenerico>;
  @Prop() public tiposSolicitud: Array<TipoSolicitud>;

  // Propiedades seleccionadas por el usuario
  @PropSync('solucion', { required: true, type: Solucion }) public solucionSelect: Solucion;
  @PropSync('tipoComision') public tipoComisionSelect: TipoComision;
  @PropSync('area') public areaSelect: IAreaConocimiento;
  @PropSync('cvu') public cvuSync: string;
  @PropSync('correo') public correoSync: string;
  @PropSync('tipoSolucion') public tipoSolucionSelect: ICatalogoGenerico;
  @Prop() public definicionEvaluacion: IDefinicionEvaluacion;
  @PropSync('definicionRevision') public definicionRevisionSync: IDefinicionRevision;
  @PropSync('estadoDocumento') public estadoDocumentoSync: EstadoDocumentoFormalizacion;
  @PropSync('estadoSolicitud') public estadoSolicitudSync: EstadoSolicitud;
  @PropSync('tipoDocumento') public tipoDocumentoSync: TipoDocumentosFormalizacion;
  @PropSync('nivelSni') public nivelSniSync: NivelSni;
  @PropSync('tipoVigencia') public tipoVigenciaSync: TipoVigencia;
  @PropSync('tipoProcesoAyudantes') public tipoProcesoAyudantesSelect: ICatalogoGenerico;
  @PropSync('cvuInvestigador') public cvuSyncInvestigador: string;
  @PropSync('solicitudId') public solicitudIdSync: string;
  @PropSync('tipoSolicitud') public tipoSolicitudSelect: TipoSolicitud;

  //Propiedades para mostrar u ocultar los selectores
  @Prop({ default: false }) public showSelectorComisiones: boolean;
  @Prop({ default: false }) public showSelectorEvaluacion: boolean;
  @Prop({ default: false }) public showSelectorAreas: boolean;
  @Prop({ default: false }) public showInputCvu: boolean;
  @Prop({ default: false }) public showInputCvuEvaluador: boolean;
  @Prop({ default: false }) public showInputCorreo: boolean;
  @Prop({ default: false }) public showSelectorEstadoDocumento: boolean;
  @Prop({ default: false }) public showSelectorEstadoSolicitud: boolean;
  @Prop({ default: false }) public showSelectorTipoSolicitud: boolean;
  @Prop({ default: false }) public showSelectorTipoDocumento: boolean;
  @Prop({ default: false }) public showMostrarOpcionesAyudantes: boolean;
  @Prop({ default: false }) public showSelectorNivelSni: boolean;
  @Prop({ default: false }) public showSelectorTipoVigencia: boolean;
  @Prop({ default: false }) public showSelectorTipoSolucion: boolean;
  @Prop({ default: false }) public showMostrarConvocatoria: boolean;
  @Prop({ default: false }) public siempreMostrarConvocatoria: boolean;
  @Prop({ default: false }) public showInputCvuInvestigador: boolean;
  @Prop({ default: false }) public showInputSolicitudId: boolean;

  //Propiedades para deshabilitar los componentes
  @Prop() public disabledButton: boolean;
  @Prop() public disabledSelectEvaluacion: boolean;
  @Prop() public disabledInputCvu: boolean;
  @Prop() public disabledInputCorreo: boolean;

  @Emit()
  public buscar(e: MouseEvent): MouseEvent {
    return e;
  }

  @Emit()
  public changeSolucion(solucion: Solucion): Solucion {
    return solucion;
  }

  @Emit()
  public changeTipoSolucion(tipoSolucionSelected: ICatalogoGenerico): ICatalogoGenerico {
    return tipoSolucionSelected;
  }

  @Emit()
  public changeTipoProcesoAyudantesSelected(tipoProcesoAyudantesSelected: ICatalogoGenerico): ICatalogoGenerico {
    return tipoProcesoAyudantesSelected;
  }
  /**
   * Llama a función que permite solo capturar números.
   * @param evt
   */
  public onlyNumbers(evt): void {
    personaUtils.onlyNumbers(evt);
  }
}
